<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryFormRef"  :inline="true" v-show="showSearch">
      <el-form-item label="名称" prop="operationName">
        <el-input v-model="queryParams.operationName" placeholder="请输入名称" clearable @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row class="btn-container mb8">
      <el-col :span="1.5">
        <el-button type="primary" v-hasPermi="['system::roleManage::add']"    @click="handleAdd()">
          新增
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-scrollbar height="calc(100vh - 170px)">
          <el-table :data="allData" v-if="refreshTable" style="width:100%" border row-key="roleId">
            <el-table-column prop="roleName" label="名称" width="180">
            </el-table-column>
            <el-table-column prop="roleCode" label="编码" width="200" align="center">
            </el-table-column>
            <el-table-column prop="roleDesc" label="描述" width="200" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
              <template #default="scope">
                <el-button  text  type="primary" v-hasPermi="['system::roleManage::distribution']"  @click="handleDistribution(scope.row)">
                  分配许可
                </el-button>
                <el-button  text type="primary" v-hasPermi="['system::roleManage::update']" @click="handleUpdate(scope.row)">
                  修改
                </el-button>
                <el-button  text type="primary"  v-hasPermi="['system::roleManage::delete']" @click="handleDelete(scope.row)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </el-col>
    </el-row>

    <!-- 添加活修改许可操作对话框 -->
    <el-dialog :title="title" v-model="dialogOpen" width="600px" append-to-body>
      <el-form ref="dialogFormRef" :model="dialogFormData" :rules="dialogFormRules" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="名称" prop="roleName">
              <el-input  v-model="dialogFormData.roleName" placeholder="请输入名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="编码" prop="roleCode">
              <el-input  v-model="dialogFormData.roleCode" placeholder="请输入编码" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="描述" prop="roleDesc">
              <el-input  v-model="dialogFormData.roleDesc" placeholder="请输入描述" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closed">{{ $t('msg.universal.cancel') }}</el-button>
          <el-button type="primary" @click="onConfirm">{{ $t('msg.universal.confirm') }}</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 分配操作对话框 -->
    <el-dialog :title="distributeDialogTitle" v-model="distributeDialogOpen" width="500px" append-to-body>
      <el-form :model="distributeDataForm" label-width="80px">
        <el-form-item label="许可名称">
          <el-input v-model="distributeDataForm.roleName" :disabled="true" />
        </el-form-item>
        <el-form-item label="操作权限">
          <el-tree  class="tree-border" :data="distributeOptions" show-checkbox default-expand-all
            ref="distributeTreeRef" node-key="permissionId" empty-text="加载中，请稍等" :props="distributeProps"></el-tree>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closedDistribute">{{ $t('msg.universal.cancel') }}</el-button>
          <el-button type="primary" @click="onConfirmDistribute">{{ $t('msg.universal.confirm') }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import {  ref } from "vue";
import { watchSwitchLang } from "@/utils/i18n";
// import { useStore } from "vuex";
import { addPermission, getPermission, modifyRole, removeRole, saveRole } from "@/api/system/role";
import { joinComma } from "@/utils/stringutil";
import useSystemStore from '@/store/modules/system'
import { warnMsg, confirmBox, succesMsg } from "@/utils/msgBox.ts"
const store = useSystemStore()
defineOptions({
    name: "roleManage",
  })  

// 查询参数
const queryParams = ref({
  operationName: ''
})
const allData = ref([])
// 是否显示搜索
const showSearch = ref(false)
// 刷新表格
const refreshTable = ref(true)
// 查询
const handleQuery = async () => {
  allData.value = await store.getAllRoles(true)
}
// 重置
const resetQuery = () => {

}

handleQuery()
watchSwitchLang(handleQuery)

// 添加
const handleAdd = () => {
  dialogReset() // 重置表单数据
  title.value = '新增'
  dialogOpen.value = true
}

// 修改
const handleUpdate = (row) => {
  dialogReset() // 重置表单数据
  dialogFormData.value = { ...row }
  dialogOpen.value = true // 显示对话框
}

// 删除
const handleDelete = async (row) => {
  confirmBox('是否确定要删除').then(async () => {
    await removeRole(row).then(resData => {
      if (resData.status === 1) {
        handleQuery()
        succesMsg('删除成功')
      }
    })
  }).catch(err => {
    })

}

// 添加许可对话框
// 对话框参数
const title = ref('')
// 对话框form 值
const dialogFormData = ref({})
// 对话框表单
const dialogFormRef = ref(null)
// 是否显示对话框
const dialogOpen = ref(false)
// 校验规则
const dialogFormRules = {
  roleName: [
    {
      required: true,
      message: '名称不能为空',
      trigger: 'blur'
    }
  ],
  roleCode: [
    {
      required: true,
      message: '编码不能为空',
      trigger: 'blur'
    }
  ]
}


// 重置对话框表单数据
const dialogReset = () => {
  dialogFormData.value = {}
  dialogFormData.value.roleId = undefined        // 机构主键
  dialogFormData.value.roleDesc = undefined      // 编码
  dialogFormData.value.roleCode = undefined      // 描述
  dialogFormData.value.roleName = undefined      // 名称
}

// 关闭
const closed = () => {
  // 重置数据
  dialogFormRef.value.resetFields()
  // 关闭对话框
  dialogOpen.value = false
}

// 提交
const onConfirm = async () => {
  dialogFormRef.value.validate(async valid => {
    // 不合规直接返回
    if (!valid) return
    let resStatus = false
    // 修改
    if (dialogFormData.value.roleId) {
      await modifyRole(dialogFormData.value).then(resData => {
        if (resData.status === 1) {
          resStatus = true
        }
      })
    } else {
      await saveRole(dialogFormData.value).then(resData => {
        if (resData.status === 1) {
          resStatus = true
        }
      })
    }

    if (resStatus) {
      closed()
      handleQuery()
    }
  })
}

// 分配权限对话框
// 参数
const distributeDialogTitle = ref('')
const distributeDialogOpen = ref(false)
const distributeDataForm = ref({})
const distributeOptions = ref([])
const distributeTreeRef = ref(null)
const distributeProps = {
  children: 'children',
  label: 'permissionName'
}


const resetDistributeDataForm = () => {
  distributeDataForm.value.roleId = '';
  distributeDataForm.value.roleName = '';
  distributeDataForm.value.permissionId = '';

}

// 获取所有操作
const getAllOperation = async () => {
  distributeOptions.value = await store.getAllPermission()
}


// 分配权限
const handleDistribution = async (row) => {
  distributeDialogOpen.value = true
  resetDistributeDataForm() // 重置数据
  getAllOperation() // 获取所有操作
  distributeDataForm.value.roleId = row.roleId
  distributeDataForm.value.roleName = row.roleName
  let checkOptions = []
  // 获取当前角色下所有许可
  await getPermission({
    roleId: row.roleId
  }).then(resData => {
    checkOptions = resData.data.map(item => item.permissionId)
    distributeTreeRef.value.setCheckedKeys(checkOptions, false)
  })
}

// 关闭分配许可
const closedDistribute = () => {
  distributeTreeRef.value.setCheckedKeys([], false)
  distributeDialogOpen.value = false
}

// 提交许可
const onConfirmDistribute = async () => {
  // 全选中节点
  const checkedKeys = distributeTreeRef.value.getCheckedKeys(false)
  let distributeIds = joinComma('', checkedKeys)
  distributeDataForm.value.permissionId = distributeIds

  await addPermission(distributeDataForm.value).then(resData => {
    if (resData.status === 1) {
      closedDistribute()
    }
  })
}
</script>

<style lang="scss" scoped>
.app-container {
  padding: 10px;

  .btn-container {
    :deep(.el-col) {
      margin-left: 5px;
    }
  }

}
</style>